import Home from "./home";
import Login from "./login";
import RegisterProcess from "./register";
import ForgotPassword from "./forgotPassword";
import ResetPassword from "./resetpassword";
import Deposit from "./deposit"
import ActiveLoan from "./activeLoan";
import RequestedLoan from "./requestedLoan";
import EMI from "./emi";
import ApplyLandingPage from './applyLoanLandingPage'
import ApplyLoan from "./applyLoan";
import ForgotPasswordOtp from './otp'
import ChangePassword from "./changepassword";
import UpdateProfile from "./updateProfile";
import LoanStatusDetails from "./loanstatusdetails";
import AboutUs from "./aboutUs";
import Terms from "./terms";
import PrivacyPolicy from "./privacyPolicy";

export default
 {
     Home,
     Login,
     RegisterProcess,
     ForgotPassword,
     ResetPassword,
     Deposit,
     ApplyLoan,
     ActiveLoan,
     RequestedLoan,
     EMI,
     ApplyLandingPage,
     ForgotPasswordOtp,
     ChangePassword,
     UpdateProfile,
     LoanStatusDetails,
     AboutUs,
     Terms,
     PrivacyPolicy
 };